"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CropperContext", {
  enumerable: true,
  get: function get() {
    return _context8.default;
  }
});
Object.defineProperty(exports, "withCropperContext", {
  enumerable: true,
  get: function get() {
    return _withCropperContext.default;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

var _constants = require("../../constants");

var _FileInput = _interopRequireDefault(require("../FileInput"));

require("./styles.css");

var _Editor = _interopRequireDefault(require("./Editor"));

var _Preview = _interopRequireDefault(require("./Preview"));

var _context8 = _interopRequireDefault(require("./context"));

var _withCropperContext = _interopRequireDefault(require("./withCropperContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cropper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Cropper, _PureComponent);

  function Cropper(props) {
    var _this;

    _classCallCheck(this, Cropper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cropper).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOnCropChange", function (crop, pixelCrop) {
      return _this.setState({
        data: {
          crop: crop,
          pixelCrop: pixelCrop
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(crop, pixelCrop) {
        var value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.validCropSize(crop, pixelCrop)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.generateValue();

              case 3:
                value = _context.sent;

                // save value to state for renderProps
                _this.setState({
                  data: {
                    crop: crop,
                    pixelCrop: pixelCrop
                  },
                  value: value
                }, function () {
                  var onChange = _this.props.onChange;

                  if (onChange) {
                    var name = _this.props.name;
                    var data = _this.state.data;
                    onChange(null, {
                      name: name,
                      value: value,
                      data: data
                    });
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "validCropSize", function (crop, pixelCrop) {
      return crop.width > 0 && crop.height > 0 || pixelCrop.width > 0 && pixelCrop.height > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "generateValue",
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var value, type, dataURL, file, info;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              value = [];
              type = _this.props.type;

              if (!(0, _lib.arrayHasItems)(type)) {
                _context3.next = 7;
                break;
              }

              _context3.next = 5;
              return (0, _lib.asyncForEach)(type,
              /*#__PURE__*/
              function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee2(t) {
                  var dataURL, file, info;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this.generateDataURL(t);

                        case 2:
                          dataURL = _context2.sent;
                          file = _this.generateFile(dataURL, t);
                          _context2.next = 6;
                          return _this.generateFileInfo(file, dataURL);

                        case 6:
                          info = _context2.sent;
                          value.push({
                            file: file,
                            info: info
                          });

                        case 8:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 5:
              _context3.next = 16;
              break;

            case 7:
              if (!type) {
                _context3.next = 16;
                break;
              }

              _context3.next = 10;
              return _this.generateDataURL(type);

            case 10:
              dataURL = _context3.sent;
              file = _this.generateFile(dataURL, type);
              _context3.next = 14;
              return _this.generateFileInfo(file, dataURL);

            case 14:
              info = _context3.sent;
              value.push({
                file: file,
                info: info
              });

            case 16:
              return _context3.abrupt("return", value);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "generateDataURL",
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(type) {
        var current, dataURL, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                current = _this.innerRef.current;

                if (!current) {
                  _context4.next = 7;
                  break;
                }

                data = _this.state.data;

                if (!type) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 6;
                return Cropper.readAsDataURL(current, data.pixelCrop, type);

              case 6:
                dataURL = _context4.sent;

              case 7:
                return _context4.abrupt("return", dataURL);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "generateFile", function (dataURL, type) {
      var fileName = _this.props.fileName;
      var name = (0, _lib.getFileName)(fileName);
      return (0, _lib.dataURLtoFile)(dataURL, "".concat(name, ".").concat(type));
    });

    _defineProperty(_assertThisInitialized(_this), "generateFileInfo",
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(file, dataURL) {
        var blob, name, ext, size, info, result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                blob = _this.props.blob;
                name = file.name;
                ext = (0, _lib.getFileExtensionFromString)(file.name);
                size = (0, _lib.readableBytes)(file.size); // general info

                info = {
                  name: name,
                  extension: ext,
                  size: size
                }; // initialized with dataURL blob

                info.blob = {
                  dataURL: dataURL
                }; // blob read file

                if (!(0, _lib.arrayHasItems)(blob)) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 9;
                return (0, _lib.asyncForEach)(blob,
                /*#__PURE__*/
                function () {
                  var _ref6 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee5(b) {
                    var result;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return _FileInput.default.readFile(file, b);

                          case 2:
                            result = _context5.sent;
                            info.blob = _objectSpread({}, info.blob, _defineProperty({}, b, result));

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x7) {
                    return _ref6.apply(this, arguments);
                  };
                }());

              case 9:
                _context6.next = 16;
                break;

              case 11:
                if (!blob) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 14;
                return _FileInput.default.readFile(file, blob);

              case 14:
                result = _context6.sent;
                info.blob = _objectSpread({}, info.blob, _defineProperty({}, blob, result));

              case 16:
                return _context6.abrupt("return", info);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleOnLoad", function (image) {
      _this.innerRef.current = image;
      var onLoad = _this.props.onLoad;

      if (onLoad) {
        onLoad();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnError", function (e) {
      var onError = _this.props.onError;

      if (onError) {
        onError(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragStart", function () {
      var onDragStart = _this.props.onDragStart;

      if (onDragStart) {
        onDragStart();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragEnd", function () {
      var onDragEnd = _this.props.onDragEnd;

      if (onDragEnd) {
        onDragEnd();
      }
    });

    var _crop = props.crop,
        ratio = props.ratio;
    _this.state = {
      prevProps: {
        crop: _crop,
        ratio: ratio
      },
      data: {
        crop: _objectSpread({}, _crop, {
          aspect: ratio
        }),
        pixelCrop: null
      }
    };
    _this.innerRef = _react.default.createRef();
    return _this;
  }

  _createClass(Cropper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onChange = _this$props.onChange,
          onLoad = _this$props.onLoad,
          onError = _this$props.onError,
          onDragStart = _this$props.onDragStart,
          onDragEnd = _this$props.onDragEnd,
          rest = _objectWithoutProperties(_this$props, ["children", "onChange", "onLoad", "onError", "onDragStart", "onDragEnd"]);

      var _this$state = this.state,
          data = _this$state.data,
          value = _this$state.value;

      var context = _objectSpread({
        data: data,
        value: value,
        onChange: this.handleOnCropChange,
        onComplete: this.handleOnChange,
        onLoad: this.handleOnLoad,
        onError: this.handleOnError,
        onDragStart: this.handleOnDragStart,
        onDragEnd: this.handleOnDragEnd
      }, rest);

      return _react.default.createElement(_context8.default.Provider, {
        value: context
      }, children ? (0, _lib.getRenderProps)(children, context) : _react.default.createElement(Cropper.Editor, null));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var crop = props.crop,
          ratio = props.ratio;
      var newData = state.data;

      if (prevProps.crop !== crop) {
        newData = _objectSpread({}, crop);
      }

      if (prevProps.ratio !== ratio) {
        newData.aspect = ratio;
      }

      return {
        // Store the previous props in state
        prevProps: {
          crop: crop,
          ratio: ratio
        },
        data: newData
      };
    }
  }]);

  return Cropper;
}(_react.PureComponent);

exports.default = Cropper;

_defineProperty(Cropper, "Consumer", _context8.default.Consumer);

_defineProperty(Cropper, "Editor", _Editor.default);

_defineProperty(Cropper, "Preview", _Preview.default);

_defineProperty(Cropper, "propTypes", {
  name: _propTypes.default.string,
  fileName: _propTypes.default.string,
  children: _common.customPropTypes.render,
  onChange: _propTypes.default.func,
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  ratio: _common.customPropTypes.stringOrNumber,
  src: _propTypes.default.string,
  crop: _propTypes.default.shape({
    aspect: _propTypes.default.string,
    x: _propTypes.default.number,
    y: _propTypes.default.number,
    width: _propTypes.default.number,
    height: _propTypes.default.number
  }),
  disabled: _propTypes.default.bool,
  keepSelection: _propTypes.default.bool,
  locked: _propTypes.default.bool,
  crossOrigin: _propTypes.default.string,
  innerRef: _common.customPropTypes.ref,
  minWidth: _propTypes.default.number,
  minHeight: _propTypes.default.number,
  maxWidth: _propTypes.default.number,
  maxHeight: _propTypes.default.number,
  // type
  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['jpeg', 'png']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['jpeg', 'png']))]),
  blob: _propTypes.default.oneOfType([_propTypes.default.oneOf(_constants.BLOB_TYPES), _propTypes.default.arrayOf(_propTypes.default.oneOf(_constants.BLOB_TYPES))])
});

_defineProperty(Cropper, "defaultProps", {
  name: null,
  fileName: null,
  children: null,
  onChange: function onChange() {},
  onLoad: function onLoad() {},
  onError: function onError() {},
  onDragStart: function onDragStart() {},
  onDragEnd: function onDragEnd() {},
  ratio: null,
  src: null,
  crop: null,
  disabled: false,
  keepSelection: false,
  locked: false,
  crossOrigin: null,
  innerRef: null,
  minWidth: 0,
  minHeight: 0,
  maxWidth: Infinity,
  maxHeight: Infinity,
  type: null,
  blob: null
});

_defineProperty(Cropper, "readAsDataURL",
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(image, pixelCrop) {
    var type,
        canvas,
        context,
        _args7 = arguments;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            type = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 'jpeg';
            canvas = document.createElement('canvas');
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;
            context = canvas.getContext('2d');
            context.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              var dataURL;

              try {
                dataURL = canvas.toDataURL("image/".concat(type));
                resolve(dataURL);
              } catch (err) {
                reject(err);
              }
            }));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}());